import React from "react";
import { Typography, Button } from "components";

const TermsAndConditions = ({ handleModalClose }) => {
  const definitions = [
    {
      title: "“the Agreement”",
      text: " The Agreement governs customer's participation in  PocketMoni mobile money services and by subscribing and participating in or continuing to use the services it shall be deemed that customers have made an affirmative statement of their unconditional acceptance of the terms and conditions contained in this Agreement.",
    },
    {
      title: "“SVA”",
      text: " means Stored Value Account and is the virtual account of the customer “Service” means the PocketMoni Services of eTranzact  International Plc",
    },
    {
      title: "“PIN”",
      text: "means the customer`s personal identification number which is known to only the customer",
    },
    {
      title: "“Mobile Phone”",
      text: " means the customer`s mobile phone whose number is indicated by the customer as the phone to be used for sending instructions to PocketMoni “Instruction” means the customer`s SMS  request to PocketMoni for the services. “PocketMoni” is the brand name of the Mobile money service",
    },
    {
      title: "“Agent”",
      text: "means a person appointed by PocketMoni to offer Mobile  money Services and includes participating Super Agent/Agent/Sub-Agent networks, further details of which may be obtained from  PocketMoni.",
    },
    {
      title: "“Outlet”",
      text: "means any premises or location thereof from which an Agent operates its business",
    },
    {
      title: "“Settlement Bank”",
      text: "means Fidelity Bank Plc which is the nominated settlement bank approved by the Central Bank of Nigeria for settlement  of all PocketMoni transactions. From time-to-time, PocketMoni may  choose to introduce more Banks as partners to the mobile payment scheme.",
    },
    {
      title: "“Bank Account”",
      text: "means a current or savings account or other account  maintained with a bank at any of the bank`s branches in Nigeria and other Country(s)",
    },
    {
      title: "“Cash”",
      text: "means the lawful currency of the Federal Republic of Nigeria.",
    },
    {
      title: "“Funds”",
      text: "means virtual money contained in customer's Account or transferred between participating parties to the Mobile Money services.",
    },
    {
      title: "“Mobile Money Services”",
      text: "means the Virtual Money transfer services  provided by PocketMoni including issuance, management and  redemption",
    },
    {
      title: "“Network”",
      text: "means the Global System for Mobile Telecommunication (“GSM”) or Code Division Multiple Access (CDMA) system operated by licensed telecommunications operators and covering those areas within the Federal Republic of Nigeria as stipulated from time to time by  PocketMoni.",
    },
    {
      title: "“Subscriber or User”",
      text: "means any person that uses the PocketMoni services by registering and subscribing to the Mobile Money Services to transmit or receive Virtual Money and includes any person that facilitates the redemption of Virtual Money",
    },
  ];

  const tAndC = [
    "The service allows the customer to deposit money, transfer money, pay bills, pay for purchases at merchant locations and withdraw cash from an agent, POS or ATM",
    "On receipt of instructions, the PocketMoni will endeavor to carry out the instructions promptly, except in situations of unforeseen circumstances such as Act of God, Force Majeure, system failure and other causes beyond PocketMoni`s control. PocketMoni shall send a confirmation of the transaction to the Customer`s Mobile Phone",
    "For the Service to be available to any customer, he/she must have completed an enrollment form at an agent location, and a confirmation received by the customer that the service has been activated",
    "Under no circumstances shall the customer allow any access to his/her account through the Service",
    "The customer instructs and authorizes PocketMoni to comply with any instructions given to PocketMoni through the use of the PIN. Once PocketMoni is instructed by means of the customer`s PIN. PocketMoni is to assume that those are the instructions given by the customer and to rely on same. PocketMoni is exempted from any form of liability whatsoever for complying with any or all instruction(s) given by means of the customer`s PIN if by any means the PIN becomes known to a third party or otherwise becomes comprised. Once a customer's PIN is given, it shall be sufficient confirmation of the authenticity of the instruction given. The customer shall be responsible for any instruction given by means of the customer's PIN. Accordingly, PocketMoni shall not be responsible for any fraudulent, duplicate or erroneous instructions given by means of the customer's PIN.",
    "The customer shall notify PocketMoni immediately if the mobile phone is lost or stolen or if it comes into the hands of a third party or if the PIN is unwittingly or otherwise disclosed or made available to third party. PocketMoni will not be liable for any damages or loss resulting from losing the mobile phone. Where oral notice of loss or theft is given, it must be confirmed in writing to the customer's agent within 48 hours.",
    "PocketMoni shall debit the customer's account with the amount of any withdrawal/transfer payment effected by the use of the mobile phone along with the related mobile money charges.",
    "PocketMoni reserves the right to limit the total cash sum withdrawn or spent by the customer during any 24 hour period. PocketMoni shall not be responsible for any loss or damage arising directly or indirectly from any malfunction or failure of the telecommunication service.",
    "PocketMoni is expressly exempted from any liability arising from unauthorized access to the customer's account and/or data via the service which arises as a result of inability and/or otherwise of the service which arises as a result of inability and/or otherwise of the",
    "PocketMoni is further relived of any liability as regards breach of duty of secrecy arising out of customer's inability to scrupulously observe and implement the provisions of these terms and conditions and/or and implement the provisions of these terms and conditions and/or access to the customer's account via service.",
    "The customer understands that his/her PIN is to be used to give instructions to PocketMoni and accordingly undertakes to be absolutely responsible for safeguarding his PIN and under no circumstances shall the customer disclose any or all of these to any person",
    "The customer undertakes to ensure the secrecy of his PIN by not reproducing same in any manner whatsoever either in writing or otherwise capable of making it known to other persons.",
    "The customer's PIN must be changed immediately it is known to anyone else and therefore the customer is under a duty to notify PocketMoni by contacting the Customer Care Centre by telephone and in writing whenever his/her PIN is suspected to have been known to another person. PocketMoni shall not be responsible for any loss that occurs between the period of such loss of memory of the PIN or knowledge of a third party and the time the report is lodged with PocketMoni",
    "The customer shall be responsible for any fraud, loss and/or liability to PocketMoni or third party arising from usage of the customer's PIN by a third party and other unauthorized access. Accordingly, PocketMoni shall not be responsible for any fraud that arises from usage of the customer's PIN",
    "The customer undertakes to ensure that his/her PIN is not one that can be easily guessed by anyone including but not limited to addresses, telephone numbers, anniversaries, birthdays, simple sequence numbers etc",
    "Upon enrolling a customer for the service, the customer may be charged the applicable monthly fee and/or usage fee",
    "Under no circumstances will PocketMoni be liable for any Under no circumstances will PocketMoni be liable for any consequential damages, losses or expenses arising in connection with consequential damages, losses or expenses arising in connection with with any failure of performance, error, omission, interruption, defect, delay in operation, transmission, line or system failure, even if PocketMoni and its representatives thereof are advised of the possibility of such damages and losses",
  ];

  return (
    <div style={{ margin: "2rem 0", width: "100%" }}>
      <div className="container">
        <Typography
          variant="subtitle1"
          state="primary"
          className={"text-center"}
        >
          TERMS AND CONDITIONS
        </Typography>
        <div className="mt-4">
          <Typography variant="body1">
            It is important that customers read these terms and conditions
            carefully as they form a legally binding agreement between them and
            PocketMoni (eTranzact Mobile Money). I (“Customer”) confirm and
            agree that the following terms and conditions shall govern my (SVA)
            with PocketMoni.
          </Typography>
          <Typography variant="subtitle1" state="primary" className={"mt-4"}>
            Definitions
          </Typography>

          {definitions.map((definition, key) => (
            <Typography className={"mt-3"} key={key}>
              <Typography state="primary" variant="body0" component={"span"}>
                {definition.title}
              </Typography>{" "}
              {definition.text}
            </Typography>
          ))}
        </div>
        <div style={{ marginTop: "3rem" }}>
          <Typography
            variant={"subtitle3"}
            state="primary"
            className={"text-center"}
          >
            TERMS AND CONDITIONS OF USE
          </Typography>
          {tAndC.map((item, key) => (
            <Typography variant="body1" className={"mt-3"}>
              {key + 1}. &nbsp; {item}
            </Typography>
          ))}
        </div>
        <div className="mt-4">
          <Button label="Back" size="sm" onClick={handleModalClose} />
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
